__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "oneview-client";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@ant-design/icons", "6.1.0", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(898)]).then(() => (() => (__webpack_require__(43160))))));
			register("antd", "6.0.0", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(898), __webpack_require__.e(495), __webpack_require__.e(764)]).then(() => (() => (__webpack_require__(25554))))));
			register("axios", "1.13.2", () => (() => (__webpack_require__(84447))), 1);
			register("react-dom", "19.2.0", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(898)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-router-dom", "7.9.6", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(898), __webpack_require__.e(495)]).then(() => (() => (__webpack_require__(11924))))));
			register("react", "19.2.0", () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(96540))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};